import PageHeader from "@/components/site/PageHeader";
import { CAPABILITIES } from "@/constants/siteData";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CapabilitiesPage() {
  return (
    <div data-testid="capabilities-page">
      <PageHeader
        eyebrow="C · Capabilities"
        title={<>Where our advisory turns <span className="text-[#1E5AF6]">strategy into outcomes.</span></>}
        description="We help companies tie their digital transformation strategy to business outcomes and goals — assessing people, technology, data, culture, leadership, governance, and industry disruptions."
        testId="capabilities-header"
      />

      <section className="py-20 md:py-28">
        <div className="container-page">
          <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-[#e5e7eb] box-elevated bg-white">
            {CAPABILITIES.map((c) => {
              const isAI = c.key === "ai";
              return (
                <article
                  key={c.key}
                  data-testid={`capability-${c.key}`}
                  className={`group relative shine border-r border-b border-[#e5e7eb] p-8 md:p-12 transition-colors duration-300 ${
                    isAI
                      ? "hover:bg-gradient-to-br hover:from-[#0B1220] hover:to-[#0E1E5A] hover:text-white"
                      : "hover:bg-[#0B1220] hover:text-white"
                  }`}
                >
                  {isAI && (
                    <span className="absolute top-0 left-0 h-[3px] w-full bg-gradient-to-r from-[#1E5AF6] via-[#23D89A] to-[#16A374]" />
                  )}
                  <div className="flex items-start justify-between gap-6 mb-8">
                    <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#4B5563] group-hover:text-white/60">
                      {c.number}
                      {isAI && (
                        <span className="ml-3 text-[#16A374] group-hover:text-[#23D89A]">
                          · Featured
                        </span>
                      )}
                    </p>
                    <ArrowUpRight className="w-6 h-6 opacity-30 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition" />
                  </div>
                  <h2 className="font-display text-2xl md:text-3xl font-bold leading-tight max-w-md">
                    {c.title}
                  </h2>
                  <p className="mt-6 text-base leading-relaxed text-[#4B5563] group-hover:text-white/80 max-w-xl">
                    {c.summary}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-[#4B5563] group-hover:text-white/60 max-w-xl">
                    {c.detail}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-[#f9fafb] border-y border-[#e5e7eb] py-24 md:py-32">
        <div className="container-page grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-8">
            <p className="eyebrow mb-4">O · Oracle</p>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter">
              Deep Oracle Fusion Cloud expertise —
              <br /> from strategy to steady state.
            </h2>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link
              to="/oracle"
              data-testid="capabilities-oracle-cta"
              className="group relative shine box-elevated inline-flex items-center gap-2 bg-[#0B1220] text-white px-7 py-4 text-sm font-semibold hover:bg-[#1E5AF6] transition-colors"
            >
              Explore Oracle offerings
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
